import { Tag } from "react-tag-autocomplete";

export enum DjangoFieldType {
    CharField = "CharField",
    TextField = "TextField",

    CUSTOM = "custom",

    ForeignKey = "ForeignKey",
    ManyToManyField = "ManyToManyField",

    DateField = 'DateField',
    TimeField = 'TimeField',
    DateTimeField = 'DateTimeField',

    BooleanField = 'BooleanField',

    BigIntegerField = 'BigIntegerField',
    IntegerField = 'IntegerField',
    SmallIntegerField = 'SmallIntegerField',
    PositiveIntegerField = 'PositiveIntegerField',
    PositiveSmallIntegerField = 'PositiveSmallIntegerField',
    BigAutoField = 'BigAutoField',
    FloatField = 'FloatField',
    DecimalField = 'DecimalField',

    JSONField = 'JSONField',
}


export enum HTMLInputType {
    Number = 'number',
    Date = 'date',
    DateTimeLocal = 'datetime-local',
    Time = 'time',
    Checkbox = 'checkbox',
    Text = 'text',
}

export interface FieldData {
    name?: string;
    verbose_name?: string;
    full_path?: string;
    field_type?: string;
    choices?: any[] | null;
    predicates?: string[] | null;
    related_fields?: FieldData | FieldData[];
}


export interface BaseEditorProps {
    fieldType: string;
    operator: string;
    value: string;
    isValid: boolean;
    setIsValid: (valid: boolean) => void;
    handleOnChange: (newValue: any) => void;
}

export interface BaseFieldEditorProps extends BaseEditorProps {
    fieldData: any
    field: any
}

export interface JSONFieldEditorProps extends BaseEditorProps {
    jsonValue: {
        search_in: string;
        value: string;
    };
}

export interface SuggestionBase {
    model_name: string;
    is_relation: boolean;
    page: number;
    num_pages: number;
    has_next: boolean;
    has_previous: boolean;
}

export interface SuggestionModelItem {
    label: string;
    value: number;
}

export interface SuggestionModelResponse extends SuggestionBase {
    results: SuggestionModelItem[];
}

export interface SuggestionFieldResponse extends SuggestionBase {
    results: string[];
}

export type SuggestionResponse = SuggestionModelResponse | SuggestionFieldResponse;

export interface Suggestion extends Tag {
    value: any;
    label: string;
}
